<div id="page-container" [class.with-sidebar]="pcs.clientSessionService.loggedIn" [class.sidebar-collapsed]="isSidebarCollapsed">
  <app-sidebar [isCollapsed]="isSidebarCollapsed"></app-sidebar>
<header [isSidebarCollapsed]="isSidebarCollapsed" (sidebarToggle)="toggleSidebar()"></header>
  <div class="container-fluid app-container {{actionLinkClass()}}" [class.with-sidebar]="pcs.clientSessionService.loggedIn" [class.sidebar-collapsed]="isSidebarCollapsed">
    <div class="router-outlet-wrapper">
      <router-outlet></router-outlet>
    </div>
    <really-click-modal></really-click-modal>
    <div id="busy-overlay" class="busy-overlay"></div>
  </div>
  <!--<footer id="footer" class="footer"></footer>-->

<div class="modal fade" tabindex="-1" role="dialog" id="busy-indicator" data-backdrop="static" style="z-index:2000 !important">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100"
            aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<unsaved-changes-dialog></unsaved-changes-dialog>
<ask-data-fab></ask-data-fab>
<a hidden id="csvDownloadLink"></a>
